import React, {useState, createContext} from 'react'
import machineSettings from '../pages/locationPage/theMachine/machineSettingsData'
import puzzleAnswers from '../pages/locationPage/puzzles/answerData'
const PuzzleChangeContext = createContext()

function PuzzleChangeProvider({children}) {
    const {maxTime} = machineSettings
    const [machineAddTime, setMachineAddTime] = useState(0)
    const [machineCount, setMachineCount] = useState(-1)
    const [machineAdaptations] = useState([
        0,
        15,
        30,
        60,
        120,
        maxTime,
        999999
    ])
    
    const {dartsJack} = puzzleAnswers
    const [dartsScoreThreshold, setDartsScoreThreshold] = useState(dartsJack)
    const [dartsCount, setDartsCount] = useState(-1)
    const [dartsAdaptations] = useState([
        dartsJack,
        (dartsJack - 10),
        (dartsJack - 15),
        (dartsJack - 20),
        (dartsJack - 40),
        0
    ])

    const [simonCount, setSimonCount] = useState(-1)
    const [rotateButtons, setRotateButtons] = useState(true)
    
    function adaptPuzzle(action) {
        const {name} = action
        
        switch(name) {
            case 'The Machine': {
                const nextCount = machineCount + 1
                if(machineCount < machineAdaptations.length) {
                    setMachineAddTime(machineAdaptations[nextCount])
                    setMachineCount(prevCount => prevCount + 1)
                }
                return console.log(`time limit increased by ${machineAdaptations[nextCount]}`) 
            }
                
            case 'The Darts Game': {
                const nextCount = dartsCount + 1
                if (nextCount < dartsAdaptations.length) {
                    setDartsScoreThreshold(dartsAdaptations[nextCount])
                    setDartsCount(prevCount => prevCount + 1)
                }
                return console.log(`score threshold is now ${dartsAdaptations[nextCount]}`) 
            }

            case 'The Simon Machine': {
                const nextCount = simonCount + 1
                nextCount > 1 && setRotateButtons(false)
                setSimonCount(prevCount => prevCount + 1)
                return console.log(`rotate buttons is now set to: ${rotateButtons}`)
            }
            
            default:
                return console.error('Something Went Wrong!')
        }
    }
        
    const context = {
        machineAddTime,
        dartsScoreThreshold,
        rotateButtons,
        adaptPuzzle
    }
    
    return (
        <PuzzleChangeContext.Provider value={context}>
            {children}
        </PuzzleChangeContext.Provider>
    )
}
                
export {PuzzleChangeProvider, PuzzleChangeContext}